<template>
	<div style="padding: 10px;min-width: 1400px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入优惠劵编码" v-model="searchInfo.code">
					<template slot="prepend">优惠劵编码</template>
				</el-input>
			</el-col>
			<el-col :span="4">
				<el-select clearable style="width: 100%;" v-model="searchInfo.category" filterable placeholder="请选择分类">
				    <el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="4">
				<el-select clearable style="width: 100%;" v-model="searchInfo.type" filterable placeholder="请选择活动类型">
				    <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;" :gutter="20">
			<el-col :span="7">
				<el-date-picker v-model="searchInfo.time" value-format="yyyy-MM-dd" type="daterange"
				      start-placeholder="开始时间"  end-placeholder="结束时间" >
				</el-date-picker>
			</el-col>
			<el-col :span="7"> 
				<el-button type="primary" @click="searchCoupons" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addCoupons">发布活动</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="couponsList"  style="width: 100%"  height="700">
			    <el-table-column fixed="left" prop="code" label="编码" width="180" align="center"></el-table-column>
				<el-table-column prop="category" label="分类" width="80" align="center"></el-table-column>
			    <el-table-column prop="typename" label="活动类型" width="80" align="center"></el-table-column>
			    <el-table-column prop="businessname" label="所属商家"  width="150" align="center"></el-table-column>
			    <el-table-column prop="userange" label="使用范围" width="80" align="center"></el-table-column>
			    <el-table-column prop="count" label="发放数量" width="80" align="center"></el-table-column>
				<el-table-column prop="linkcount" label="已领用数量" width="100" align="center"></el-table-column>
				<el-table-column prop="usecount" label="已使用数量" width="100" align="center"></el-table-column>
				<el-table-column prop="validtime" label="活动时间" align="center"></el-table-column>
				<el-table-column prop="content" label="优惠内容" width="120" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goCouponDetail(scope.$index, scope.row)" title="优惠劵详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-s-ticket">详情</i>
						</a>
						<a @click="putDownCoupon(scope.$index, scope.row)" title="暂停活动" style="cursor:pointer;margin-left: 10px;color: #E6A23C;">
							<i class="el-icon-video-pause">暂停</i>
						</a>
						<a @click="deleteCoupons(scope.$index, scope.row)" title="删除活动" style="cursor:pointer;margin-left: 10px;color: #F56C6C;">
							<i class="el-icon-delete">删除</i>
						</a>
						<!-- <a v-show="scope.row.state == 'up'" @click="putDownFood(scope.$index, scope.row)" title="下架菜品" style="cursor:pointer;margin-left: 10px;color: #E6A23C;">
							<i class="el-icon-bottom">下架</i>
						</a>
						<a v-show="scope.row.state == 'down'" @click="putUpFood(scope.$index, scope.row)" title="上架菜品" style="cursor:pointer;margin-left: 10px;color: #67C23A;">
							<i class="el-icon-top">上架</i>
						</a>
						 -->
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="couponsTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" :width="dialogWidth" :visible.sync="couponsdetailShow">
			<CouponsDetail v-if="showtype == 'detail'" :info="selectcoupon"></CouponsDetail>
			<AddCoupons v-if="showtype == 'add'" @couponNeedRefrash="needRefrash"></AddCoupons>
		</el-dialog>
		
	</div>
</template>

<script>
	import CouponsDetail from './couponsdetail.vue'
	import AddCoupons from './addcoupons.vue'
	import {queryCouponsLists, stopCoupons, deleteCoupons} from '/static/apiUrl.js'
	export default {
		name : 'CouponsMng',
		data() {
			return {
				couponsdetailShow : false,
				detailTitle : '优惠劵详情',
				dialogWidth : '70%',
				showtype: '',
				categoryList : [
					{
						label : '所有分类',
						value : '',
					},
					{
						label : '平台',
						value : 'platform',
					},
					{
						label : '商家',
						value : 'business',
					},
				],				
				typeList : [
					{
						label : '所有优惠券类型',
						value : 'all',
					},
					{
						label : '现金',
						value : 'cash',
					},
					{
						label : '折扣',
						value : 'discount',
					},
					{
						label : '满减',
						value : 'fullreduction',
					},
				],
				searchInfo : {
					code : '',
					userId: '',
					category: '',
					type : 'all',
					begin : '',
					end : '',
					time : ''
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				selectcoupon : null,
				couponsTotal : 0,
				couponsList : [/* {
					code : 'PT00000001',
					type : 'cash',
					typename : '现金',
					businessname : '',
					stallname : '',
					category : 'platform',
					userange : '所有档口',
					count : 100,
					linkcount : 50,
					usecount : 10,
					validtime : '2024-10-01 ~ 2024-10-30',
					content : '抵扣5元'
				} */]
			}
		},
		mounted() {
			//console.log('menu')
			this.searchCoupons()
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryCoupons()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryCoupons()
			},
			goCouponDetail(idx,row){
				console.log(idx,row)
				this.detailTitle = '活动详情'
				this.showtype = "detail"
				this.dialogWidth = '70%'
				this.selectcoupon = row
				this.couponsdetailShow = true
			},
			putDownCoupon(idx,row){
				//console.log(idx,row)
				this.$confirm('此操作将终止未被领取的优惠券, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					stopCoupons({
						userId : '',
						code: row.code
					}).then(res => {
						if(0 == res.code){
							this.queryCoupons()
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					
				});
			},
			deleteCoupons(idx,row){
				//console.log(idx,row)
				this.$confirm('此操作将删除未被领取的优惠券, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					deleteCoupons({
						userId : '',
						code: row.code
					}).then(res => {
						if(0 == res.code){
							this.queryCoupons()
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					
				});
			},
			searchCoupons(){
				console.log(this.searchInfo)
				this.param.page = 1
				this.queryCoupons()
			},
			queryCoupons(){
				this.couponsList = []
				queryCouponsLists({
					usrId: "",
					code: this.searchInfo.code,
					category: this.searchInfo.category,
					type: this.searchInfo.type,
					begin: this.searchInfo.time ? this.searchInfo.time[0] + ' 00:00:00' : '',
					end: this.searchInfo.time ? this.searchInfo.time[1] + ' 23:59:59': '',
					pageIndex: this.param.page,
					pageSize: this.param.pagenum
				}).then(res => {
					if(0 == res.code){
						console.log(res)
						this.couponsTotal = res.data.total
						if(res.data.data){
							res.data.data.forEach((item) => {
								this.couponsList.push({
									code : item.Coupons_Code,
									type : item.Coupons_Type,
									typename : this.getCouponsTypeName(item.Coupons_Type),
									businessname : item.BusinessName,
									stallname : item.StallName,
									category : item.Coupons_Category=="platform"?'平台':"商家",
									userange : 'platform' ==item.Coupons_Category ? '所有档口' : item.StallName,
									count : item.AllCount,
									linkcount : item.GetCount,
									usecount : item.UseCount,
									validtime : item.Coupons_Begintime.substr(0,10) + ' ~ ' + item.Coupons_Overtime.substr(0,10),
									content : this.getCouponsContext(item.Coupons_Type,item),
									discount : item.Coupons_Deductionamount,
									percent : item.Coupons_Discountratio,
									fullreduct : item.Coupons_Fullreduction
								})
							})
						}
					}
				})
			},
			getCouponsTypeName(val){
				if('cash' == val){
					return '现金'
				}else if('discount' == val){
					return '折扣'
				}else if('fullreduction' == val){
					return '满减'
				}
				return ''
			},
			getCouponsContext(type,val){
				if('cash' == type){
					return '抵扣' + val.Coupons_Deductionamount+'元'
				}else if('discount' == type){
					return val.Coupons_Discountratio+'折'
				}else if('fullreduction' == type){
					try{
						let temp = val.Coupons_Fullreduction.split("-")
						return '满 '+temp[0]+' 减 '+temp[1]
					}catch(e){ console.log(e) }
				}
				return ''
			},
			addCoupons(){
				this.detailTitle = '发布平台活动'
				this.selectcoupon = null
				this.showtype = "add"
				this.dialogWidth = '50%'
				this.couponsdetailShow = true
			},
			refrashData() {
				this.searchCoupons()
			},
			needRefrash(val) {
				if(val){
					this.couponsdetailShow = false
				}
			},
			clearSearch() {
				this.searchInfo.category = '' 
				this.searchInfo.code = '' 
				this.searchInfo.userId = ''
				this.searchInfo.type = ''
				this.searchInfo.begin = ''
				this.searchInfo.end = ''
				this.searchInfo.time = ''
			}
		},
		components: {
			CouponsDetail,
			AddCoupons
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>